import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { publishProcedure } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postPublishProcedure({
  accountId,
  makeProceduresVisible,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    publishProcedure(accountId, makeProceduresVisible),
    {
      method: 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  params: Array<string>;
  makeProceduresVisible?: boolean;
};

type TSnapshot = unknown;

function usePublishProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ accountId, params, makeProceduresVisible }: TVariables) => {
      const postResult = await postPublishProcedure({
        accountId,
        params,
        makeProceduresVisible,
      });

      if (postResult.Data) {
        queryClient.invalidateQueries(
          ['get_procedure_builder_procedures', accountId],
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(['get_procedure', accountId], {
          refetchInactive: true,
        });
      } else if (postResult.Errors) throw postResult;
      return postResult;
    },
  );
}

export { usePublishProcedure };
